export default function isPositiveInt(n) {
    var numStr = /^[0-9]\d*$/;
    return numStr.test(n.toString());
}
